import { ChevronRight } from "@material-ui/icons";
import { Button } from "components/ThemedComponent/Common";
import Link from "next/link";
import React, { useRef } from "react";
import { styled } from "theme";
import { getUrlPath } from "utils/helpers";
import Image from "next/image";

const PopularCompanies = () => {
	const ref = useRef<HTMLDivElement>(null);

	const handleClick = (item, index) => {
		import("../../../utils/Mixpanel").then((Mixpanel) => {
			Mixpanel.default.track("Popular Company Clicked", {
				page: getUrlPath(),
				screen: "HomePage",
				Company: item.title,
				position: index + 1,
			});
		});
	};

	const handleViewAllClick = () => {
		import("../../../utils/Mixpanel").then((Mixpanel) => {
			Mixpanel.default.track("Popular Companies View All Clicked", {
				page: getUrlPath(),
				screen: "HomePage",
			});
		});
	};

	return (
		<div className="bg-[#F4F2F6] px-4 py-[72px] text-center md:py-[100px]">
			<h3 className="px-4 text-center text-[32px] font-bold leading-[48px]">
				Job Openings in Top companies
			</h3>
			<div
				className="scrollbarHide -mx-4 mt-12  flex overflow-y-visible overflow-x-scroll px-4 pb-20 md:mt-[80px] md:px-[100px]"
				onScroll={(e) => {
					const { scrollLeft: scrollLeftBig, scrollWidth: scrollWidthBig } =
						e.currentTarget;

					const newLeft = (64 * scrollLeftBig) / scrollWidthBig;
					ref.current.style.left = `${newLeft}px`;
				}}
			>
				{popularCompanies.map((item, index) => (
					<Link href={item.url} passHref>
						<Company
							onClick={() => handleClick(item, index)}
							className="md:min-w-auto mr-6 flex min-w-[80%] flex-col rounded-xl border bg-[#FAFAFA] p-4 text-left transition-all hover:bg-white hover:shadow-400 md:min-w-[402px] md:p-6"
						>
							<div className="relative h-[64px] w-auto max-w-[120px] ">
								<Image
									src={item.image}
									alt={item.title}
									layout="fill"
									objectPosition="left"
									objectFit="contain"
								/>
								{/* <div className="text-right">
								<p className="m-0 text-md font-bold text-[#27a64e]">
									glassdoor
								</p>
								<StarRating showNumericRating rating={3} />
							</div> */}
							</div>

							<h4 className="mb-0 mt-6 text-md font-semibold md:mt-[40px] md:text-[20px] md:font-bold">
								{item.title}
							</h4>
							<p className="mt-3 text-md">{item.description}</p>
							<span className="mt-auto inline-block self-start rounded-lg px-[14px] py-[11px] font-semibold text-green-500 transition-all  hover:bg-[#1F8268] hover:text-white md:mt-auto">
								View jobs &nbsp;
								<ChevronRight fontSize="small" />
							</span>
						</Company>
					</Link>
				))}
			</div>

			{/* Small scroll */}
			<div className="-mt-10 text-center">
				<div className="relative mx-auto h-1 w-[64px] rounded-lg bg-[#D1CED4]">
					<span
						ref={ref}
						className="absolute left-0 top-[-2px] inline-block h-2 w-5 rounded-lg bg-[#1F8268]"
					/>
				</div>
			</div>

			<Link href="/job-search?keyword=Jobs+By+Company" passHref>
				<Button
					as="a"
					onClick={handleViewAllClick}
					variant="primary"
					className="!mx-auto mt-12 !h-[56px] !w-full !py-4 !font-semibold md:mt-[80px] md:max-w-[292px]"
					outline
					size="large"
				>
					View all &nbsp; <ChevronRight fontSize="small" />
				</Button>
			</Link>
		</div>
	);
};

export default PopularCompanies;

const Company = styled.a`
	&:hover {
		cursor: pointer;
		span {
			color: white;
			background: #1f8268;
		}
	}
`;

const popularCompanies = [
	{
		title: "Bajaj Allianz Life Insurance",
		image: "https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/companies/bajaj.png",
		description: "Provider of life insurance and financial services.",
		url: "/jobs/bajaj_allianz_life_insurance_company_limited-jobs",
	},
	{
		title: "Paytm Service Pvt. Ltd.",
		image: "https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/companies/ic-paytm.png",
		description: "Digital payment and e-commerce facilitator.",
		url: "/jobs/paytm_service_pvt_ltd-jobs",
	},
	{
		title: "Zomato",
		image: "https://apna-organization-logos.gumlet.io/production/322333?w=128",
		description: "Online food delivery marketplace.",
		url: "/jobs/zomato-jobs",
	},
	{
		title: "Swiggy",
		image: "https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/companies/ic-swiggy.png",
		description: "Food delivery and online ordering platform.",
		url: "/jobs/swiggy-jobs",
	},
	{
		title: "Kotak Life Insurance",
		image: "https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/companies/kotak-life.png",
		description: "Life insurance and financial services company.",
		url: "/jobs/kotak_life_insurance_ltd-jobs",
	},
	{
		title: "Zepto",
		image: "https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/companies/zepto.png",
		description: "Delivery and logistics services facilitator.",
		url: "/jobs/zepto-jobs",
	},
	{
		title: "Tata AIA",
		image: "https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/companies/tata-aia.png",
		description: "Life insurance and financial services organization.",
		url: "/jobs/tata_aia_life-jobs",
	},

	{
		title: "Bharti Axa Life Insurance Company Limited",
		image: "https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/companies/bharti-axa.png",
		description: "Life insurance and financial services enterprise.",
		url: "/jobs/bharti_axa_life_insurance_company_limited-jobs",
	},
	{
		title: "Okaygo",
		image: "https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/companies/okay-go.png",
		description: "On-demand services aggregator.",
		url: "/jobs/okaygo-jobs",
	},
	{
		title: "Aditya Birla Capital Limited",
		image: "https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/companies/birla.png",
		description: "Financial services and investment management provider.",
		url: "/jobs/aditya_birla_capital_limited-jobs",
	},

	{
		title: "Max Life Insurance",
		image: "https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/companies/max-life.png",
		description: "Life insurance and financial services company.",
		url: "/jobs/max_life_insurance-jobs",
	},
	{
		title: "Teamlease",
		image: "https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/companies/team-lease.png",
		description: "Staffing and HR solutions partner.",
		url: "/jobs/teamlease_services_limited-jobs",
	},
	{
		title: "Flipkart",
		image: "https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/companies/flipkart.png",
		description: "E-commerce and online shopping marketplace.",
		url: "/jobs/flipkart-jobs",
	},
	{
		title: "Lic India",
		image: "https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/companies/lic.png",
		description: "Life insurance and financial services organization.",
		url: "/jobs/lic-jobs",
	},
	{
		title: "Reliance Jio",
		image: "https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/companies/reliance-jio.png",
		description: "Telecommunications and digital services provider.",
		url: "/jobs/reliance_jio-jobs",
	},

	{
		title: "SBI LIFE Insurance company",
		image: "https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/companies/sbi-life.png",
		description: "Life insurance and financial services provider.",
		url: "/jobs/sbi_life_insurance_company_limited-jobs",
	},
	{
		title: "Hdfc Life Insurance Company Limited",
		image: "https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/companies/hdfc.png",
		description: "Life insurance and financial services firm.",
		url: "/jobs/hdfc_life_insurance_company_limited-jobs",
	},
];
